import {take, uniq} from 'lodash';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export interface PrevSelectedData {
  apartment: string[];
  house: string[];
  counter: string[];
}

interface PrevSelectedStore {
  data: PrevSelectedData;
  setData: (key: keyof PrevSelectedData, value: string) => void;
}

export const usePrevSelectedStore = create<PrevSelectedStore>()(
  persist(
    (set) => ({
      data: {apartment: [], house: [], counter: []},
      setData: (key: keyof PrevSelectedData, value: string) => {
        set((state) => ({data: {...state.data, [key]: take(uniq([value, ...state.data[key]]), 5)}}));
      },
    }),
    {name: 'prev-selected-store'},
  ),
);
